import { render, staticRenderFns } from "./AccessDeniedComponent.vue?vue&type=template&id=ce30dc7c&scoped=true"
import script from "./AccessDeniedComponent.vue?vue&type=script&lang=ts"
export * from "./AccessDeniedComponent.vue?vue&type=script&lang=ts"
import style0 from "./AccessDeniedComponent.vue?vue&type=style&index=0&id=ce30dc7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce30dc7c",
  null
  
)

export default component.exports